import { render } from "./WCCarousel.vue?vue&type=template&id=630a9ac7&scoped=true"
import script from "./WCCarousel.vue?vue&type=script&lang=js"
export * from "./WCCarousel.vue?vue&type=script&lang=js"

import "./WCCarousel.vue?vue&type=style&index=0&id=630a9ac7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630a9ac7"]])

export default __exports__